module.exports = __webpack_public_path__ + "img/box.676f2733.png";